import { render, staticRenderFns } from "./quickLogin.vue?vue&type=template&id=079e222c&scoped=true&"
import script from "./quickLogin.vue?vue&type=script&lang=js&"
export * from "./quickLogin.vue?vue&type=script&lang=js&"
import style0 from "./quickLogin.vue?vue&type=style&index=0&id=079e222c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e222c",
  null
  
)

export default component.exports